export default __webpack_public_path__ + "assets/media/offline_kk.34f19c6b.txt";